export const isPackageTypeInternet = (packageType) => {
    if (packageType === null || packageType === undefined) return false;
    return packageType?.toString().toLocaleUpperCase("en-US") === 'INTERNET';
}

export const isPackageTypeChat = (packageType) => {
    if (packageType === null || packageType === undefined) return false;
    return packageType?.toString().toLocaleUpperCase("en-US") === 'CHAT';
}

export const isUnitTypeHour = (unitType) => {
    if (unitType === null || unitType === undefined) return false;
    return unitType?.toString().toLocaleUpperCase("en-US").indexOf('HOUR') >= 0;
}

export const isUnitTypeMinutes = (unitType) => {
    if (unitType === null || unitType === undefined) return false;
    return unitType?.toString().toLocaleUpperCase("en-US") === 'MINUTES';
}
